module.exports = '2.4.0';



// WEBPACK FOOTER //
// ./src/version.js